import { useForm } from '@tanstack/react-form';
import { useUpdateCurrentUserMutation } from './mutations/use-update-current-user.mutation';
import { UpdateUserRequest } from '@/types/api/user';
import { UpdateUserSchema } from '@/validators/user/update-user.schema';

export function useUpdateUserForm(initialValues?: UpdateUserRequest) {
  const mutation = useUpdateCurrentUserMutation();

  return useForm<UpdateUserRequest>({
    defaultValues: {
      firstName: initialValues?.firstName || '',
      lastName: initialValues?.lastName || '',
      email: initialValues?.email || '',
      mobileNumber: initialValues?.mobileNumber || '',
    },
    validators: { onSubmit: UpdateUserSchema },
    onSubmit: async ({ value }) => {
      await mutation.mutateAsync({ ...value });
    },
  });
}
